import React, { useEffect, useState } from "react";
import "./WallsTab.css";
import WallSelector, { UiWall } from "./components/WallSelector";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import { Wall } from "src/types/configuration";
import ColorSelect from "src/components/Input/Select/ColorSelect";
// @ts-ignore
import isEqual from "lodash/isEqual";
import Text from "src/components/Text/Text";
import Switch from "src/components/Input/Switch/Switch";
import { useTabScroll } from "src/contexts/TabScrollContext";
import HorizontalSwitch from "src/components/Input/HorizontalSwitch/HorizontalSwitch";
import RadioBlocksExtended from "src/components/Input/RadioBlocksExtended/RadioBlocksExtended";
import SelectUnselectExtended from "src/components/SelectUnselectExtended/SelectUnselectExtended";

const glassShadesDoors = [
  {
    id: 0,
    name: "Helder",
    value: "light",
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_door_light.png`,
    price: 0,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 1,
    name: "Zonwerend",
    value: "dark",
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_door_dark.png`,
    price: 0,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
];

const glassShadesWindows = [
  {
    id: 0,
    name: "Helder",
    value: "light",
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_window_light.jpg`,
    price: 0,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 1,
    name: "Zonwerend",
    value: "dark",
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_window_dark.jpg`,
    price: 0,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
];

interface WallComponentProps {
  wall: Wall;
  onWallChange: (wall: Wall) => void;
}

const WoodWallComponent: React.FC<WallComponentProps> = ({
  wall,
  onWallChange,
}) => {
  const { state, configurator, configuration, setSpy, setOptionsMaterial } =
    useConfiguration();
  // const [spyName, setSpyName] = useState("none");

  // useEffect(() => {
  //   setSpyName(getspy());
  // }, [state.spy]);

  const handleGlassDark = (value: string) => {
    const bool = value === "dark" ? true : false;
    handleGlassDarkChange(bool);
  };

  // const GlassShadeComponent = () => {
  //   return (
  //     <>
  //       <RadioBlocksExtended
  //         blocks={glassShades}
  //         value={wall.glassDark ? "dark" : "light"}
  //         onChange={handleGlassDark}
  //         className={"inner_child"}
  //         // parentIsSelected={parentIsSelected}
  //       />
  //     </>
  //   );
  // };

  const DoorComponent = () => {
    return (
      <>
        <RadioBlocksExtended
          blocks={glassShadesDoors}
          value={wall.glassDark ? "dark" : "light"}
          onChange={handleGlassDark}
          className={"inner_child"}
          parentIsSelected={wall.woodWall.outerColor.startsWith("door")}
        />
        <Text content="Schuifrichting, vanuit" />
        <HorizontalSwitch
          value={wall.orientation}
          values={[
            { id: 0, label: "Links", value: "left" },
            { id: 1, label: "Midden", value: "middle" },
            { id: 2, label: "Rechts", value: "right" },
          ]}
          onChange={handleOrientationChange}
        />
      </>
    );
  };

  const WindowComponent = () => {
    return (
      <>
        <RadioBlocksExtended
          blocks={glassShadesWindows}
          value={wall.glassDark ? "dark" : "light"}
          onChange={handleGlassDark}
          className={"inner_child"}
          parentIsSelected={wall.woodWall.outerColor.startsWith("window")}
        />
      </>
    );
  };

  const sideWall =
    wall.id === `v-0-${configurator.getColumns()}` || wall.id === `v-0-0`
      ? true
      : false;

  const outerColors = [
    {
      id: 0,
      name: "Glazen schuifwand",
      imageUrl: `${process.env.PUBLIC_URL}/images/ver-door-screenshot.png`,
      color: "",
      value: "door_3x3Tracks",
      price: 0,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      component: DoorComponent,
      selectedNames: glassShadesDoors.find(
        (i) => i.value === (wall.glassDark ? "dark" : "light")
      )?.name,
      carouselImages: glassShadesDoors.map((i) => i.imageUrl),
    },
    {
      id: 1,
      name: "Glazen schuifwand steellook",
      imageUrl: `${process.env.PUBLIC_URL}/images/ver-window-screenshot.png`,
      color: "",
      value: "window_2x2Tracks",
      price: 0,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      component: WindowComponent,
      selectedNames: glassShadesWindows.find(
        (i) => i.value === (wall.glassDark ? "dark" : "light")
      )?.name,
      carouselImages: glassShadesWindows.map((i) => i.imageUrl),
    },
    {
      id: 2,
      name: "Aluminium wand",
      imageUrl: `${process.env.PUBLIC_URL}/images/ver-alum-screenshot.png`,
      color: "",
      value: "aluminiumWall",
      price: 0,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    },
  ];

  window.CONF.house.walls.map((item) => {
    if (
      (wall.position.end.x === item.end.x &&
        wall.position.end.y === item.end.y &&
        wall.position.start.x === item.start.x &&
        wall.position.start.y === item.start.y) ||
      (wall.position.end.x === item.start.x &&
        wall.position.end.y === item.start.y &&
        wall.position.start.x === item.end.x &&
        wall.position.start.y === item.end.y)
    ) {
      const cols = configurator.getColumns();
      const isLeft = wall.position.start.x === 0 && wall.position.end.x === 0;
      const isRight =
        wall.position.start.x === cols && wall.position.end.x === cols;

      outerColors.map((localitem) => {
        if (localitem.value === "aluminiumWall")
          localitem.price = configuration.calculationService.GetAlum(
            item.sections[0].length,
            isLeft,
            isRight
          );
      });
    }
  });

  useEffect(() => {
    // console.log(wall.position.end, wall.position.start);
    window.CONF.house.walls.map((item) => {
      if (
        wall.position.end.x === item.end.x &&
        wall.position.end.y === item.end.y &&
        wall.position.start.x === item.start.x &&
        wall.position.start.y === item.start.y
      ) {
        outerColors.map((localitem) => {
          if (localitem.value === "aluminiumWall") localitem.price = 100;
        });
      }
    });
  }, [wall]);

  const handleOuterColor = (outerColor: string) => {
    if (outerColor === "") return;
    if (wall.woodWall.outerColor === outerColor) return;
    const woodWall = { ...wall.woodWall };
    woodWall.outerColor = outerColor;
    wall.glassDark = false;
    const columns = configurator.getColumns();

    // console.log(wall.id);
    const id = wall.id;
    const leftwall = id === "v-0-0";
    const rightwall = id === `v-0-${columns}`;
    const alumwall = outerColor.startsWith("alum");
    if (leftwall && !alumwall) setSpy({ ...state.spy, left: true });
    else if (rightwall && !alumwall) setSpy({ ...state.spy, right: true });

    const updateWall = { ...wall, woodWall: woodWall };
    if (!isEqual(wall, updateWall)) onWallChange(updateWall);

    // let doorcheck = false;
    // window.CONF.house.walls.map((item) => {
    //   if (item.sections[0].type.startsWith("door")) doorcheck = true;
    // });
    // if (!doorcheck)
    //   setOptionsMaterial({ ...state.optionsMaterial, fundering: "empty" });
  };

  const handleLessTracksChange = (value: boolean) => {
    if (!isEqual(wall.lessTracks, value))
      onWallChange({ ...wall, lessTracks: value });
  };
  const handleOrientationChange = (value: string) => {
    if (!isEqual(wall.orientation, value))
      onWallChange({ ...wall, orientation: value });
  };

  const handleGlassDarkChange = (value: boolean) => {
    if (!isEqual(wall.glassDark, value))
      onWallChange({ ...wall, glassDark: value });
  };

  const handleAlSpyChange = (value: boolean) => {
    if (!isEqual(state.spy.left, value) || !isEqual(state.spy.right, value)) {
      const temp =
        wall.id === "v-0-0"
          ? { left: value }
          : wall.id === `v-0-${configurator.getColumns()}`
          ? { right: value }
          : {};
      setSpy({ ...state.spy, alumspy: value, ...temp });
    }
  };

  return (
    <>
      <RadioBlocksExtended
        blocks={
          sideWall
            ? outerColors.filter((value) => value.value !== "window_2x2Tracks")
            : outerColors.filter((value) => value.value !== "aluminiumWall")
        }
        value={wall.woodWall.outerColor}
        onChange={handleOuterColor}
        // label={label}
        // className={"inner_child"}
      />

      {/* <RadioBlocksExtended
        blocks={[
          { id: 0, name: "Recht", value: "default" },
          { id: 1, name: "Rond", value: "rond" },
          { id: 2, name: "Klassiek", value: "klassiek" },
        ]}
        value={wall.woodWall.outerColor}
        onChange={handleOuterColor}
        // className={"inner_child"}
      /> */}
    </>
  );
};

const WallsTab: React.FC = () => {
  const { state, addWall, setWalls, configuration, configurator, setSpy } =
    useConfiguration();
  const [selectedWall, setSelectedWall] = useState<UiWall | null>(null);
  const [activeWalls, setActiveWalls] = useState<string[]>([]);
  const [storageWalls, setStorageWalls] = useState<string[]>([]);
  const [wall, setWall] = useState<Wall>(
    configuration.findWallbyUiWall(selectedWall)
  );
  const { scrollTo } = useTabScroll();

  const handleSelectedWall = (newUiWall: UiWall | null) => {
    if (!wall) return;

    const newWall = configuration.findWallbyUiWall(newUiWall);

    if (newWall.storage !== "empty") {
      return;
    }

    const columns = configurator.getColumns();

    if (newUiWall?.id === `v-0-${columns}`) {
      newWall.isRightSide = true;
    }

    setSelectedWall(newUiWall);
    setWall(newWall);

    configurator.focusOnWall(newWall);
    configurator.selectWall(newWall);

    // scroll to top
    setTimeout(() => {
      const tabElement = document.querySelector(`.walls-tab .wall-wood-wall`);
      if (tabElement) scrollTo(tabElement);
    }, 80);
  };

  useEffect(() => {
    // console.log(wall.position.end, wall.position.start);
    window.CONF.house.walls.map((item) => {
      if (
        (wall.position.end.x === item.end.x &&
          wall.position.end.y === item.end.y &&
          wall.position.start.x === item.start.x &&
          wall.position.start.y === item.start.y) ||
        (wall.position.end.x === item.start.x &&
          wall.position.end.y === item.start.y &&
          wall.position.start.x === item.end.x &&
          wall.position.start.y === item.end.y)
      ) {
        glassShadesDoors.map(
          (localitem) =>
            (localitem.price =
              configuration.calculationService.getSlidingDoorsPrice(
                item.sections[0].length,
                localitem.value
              ))
        );

        glassShadesWindows.map(
          (localitem) =>
            (localitem.price = configuration.calculationService.getWindowsPrice(
              item.sections[0].length,
              localitem.value
            ))
        );
      }
    });
  }, [wall]);

  const handleWallChange = (updatedWall: Wall) => {
    if (!wall) return;

    if (!isEqual(wall, updatedWall)) {
      addWall(updatedWall);
      setWall(updatedWall);
    }
  };

  const handleWallDelete = (newUiWall: UiWall | null) => {
    setSelectedWall(null);
    configurator.deselectWalls();
    if (wall.id === "v-0-0") {
      setSpy({ ...state.spy, left: false });
    }
    if (wall.id === `v-0-${configurator.getColumns()}`) {
      setSpy({ ...state.spy, right: false });
    }

    if (!wall) return;
    if (wall.storage === "empty")
      setWalls(state.walls.filter((wall) => wall.id !== newUiWall?.id));
  };

  useEffect(() => {
    if (!wall) return;

    setActiveWalls(
      state.walls
        .filter((wall) => {
          if (wall.storage !== "empty") return false;
          if (wall.slidingGlassWall !== "empty") return true;
          return wall.woodWall.outerColor !== "empty";
        })
        .map((wall) => wall.id)
    );

    setStorageWalls(
      state.walls
        .filter((wall) => {
          return wall.storage !== "empty";
        })
        .map((wall) => wall.id)
    );
  }, [state.walls, wall]);

  const getspy = () => {
    const left: boolean = state.spy.left;
    const right: boolean = state.spy.right;

    return left && right
      ? "both"
      : !left && !right
      ? "none"
      : right
      ? "rechts"
      : "links";
  };

  const handleSpyState = (left: boolean, right: boolean) => {
    if (state.spy.left === left && state.spy.right === right) return;
    setSpy({ ...state.spy, left: left, right: right });
  };

  const handleSpy = (value: string) => {
    if (value === "none") {
      handleSpyState(false, false);
    } else if (value === "both") {
      handleSpyState(true, true);
    } else if (value === "rechts") {
      handleSpyState(false, true);
    } else if (value === "links") {
      handleSpyState(true, false);
    }
  };

  const spies = [
    {
      id: 0,
      label: "Geen",
      value: "none",
    },
    { id: 1, label: "Links", value: "links" },
    { id: 2, label: "Rechts", value: "rechts" },
    { id: 3, label: "Links & rechts", value: "both" },
  ];

  const SpyComponent = () => {
    return (
      <>
        {/* <Switch
          label={"Spy"}
          value={wall.id === "v-0-0" ? state.spy.left : state.spy.right}
          onChange={handleAlSpyChange}
        /> */}
        <HorizontalSwitch
          value={getspy()}
          values={spies}
          onChange={handleSpy}
        />
      </>
    );
  };

  return (
    <div className="walls-tab">
      <div className="walls-selector-container">
        <WallSelector
          onWallSelect={handleSelectedWall}
          onWallDeselect={handleWallDelete}
          activeWalls={activeWalls}
          storageWalls={storageWalls}
        />
      </div>

      {selectedWall && (
        <WoodWallComponent wall={wall} onWallChange={handleWallChange} />
      )}
      {state.roofType === "oase" && (
        <>
          {/* <RadioBlocksExtended
            blocks={[
              {
                id: 3,
                name: "Spie optie",
                imageUrl: `${process.env.PUBLIC_URL}/images/ver_spie.png`,
                // color: "",
                value: "",
                price: 0,
                description:
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                component: SpyComponent,
              },
            ]}
            value={" "}
            onChange={() => null}
            // label={label}
            // className={"inner_child"}
          /> */}
          <SelectUnselectExtended
            name="Spie optie"
            imageUrl={`${process.env.PUBLIC_URL}/images/ver_spie.png`}
            description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
            isSelected={state.spy.left || state.spy.right}
            onSelect={
              // () => {
              // handleSpy("both");
              // }
              () => true
            }
            onUnselect={
              // () => {
              // handleSpy("none");
              // }
              () => false
            }
            Component={SpyComponent}
            alwaysShowSelected={true}
            selectedNames={
              spies.find((i) => i.value === getspy() && i.value !== "none")
                ?.label || ""
            }
            price={configuration.calculationService.getSpie(
              state.spy.left,
              state.spy.right
            )}
          />
        </>
      )}
    </div>
  );
};

export default WallsTab;
